import React from "react";
import { Box, Paper } from "@material-ui/core";
import ProfileImage from "./ProfileImage";
import ProfileInfo from "./ProfileInfo";
import ProfileButtons from "./ProfileButtons";

const PatientProfileContainer = ({
  patient,
  classes,
  match,
  location,
  params,
  onToggleActivationClick,
}) => {
  return (
    <Box component={Paper} className={classes.profileContainer}>
      <Box className={classes.profileContentContainer}>
        <Box>
          <ProfileImage patient={patient} classes={classes} />
        </Box>
        <Box className={classes.profileTextContainer}>
          <ProfileInfo patient={patient} classes={classes} />
          <ProfileButtons
            patient={patient}
            classes={classes}
            match={match}
            location={location}
            params={params}
            onToggleActivationClick={onToggleActivationClick}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default PatientProfileContainer;
